import { Button, ButtonProps } from 'src/components/design-system/form/buttons/Button'
import { FC, ReactElement } from 'react'
import classNames from 'classnames'
import './module.scss'

export type PrimaryButtonProps = ButtonProps

export const PrimaryButton: FC<PrimaryButtonProps> = (props: PrimaryButtonProps): ReactElement => {
    return <Button {...props} className={classNames(props.className, 'primary-button')} />
}